import { defineMessages } from 'react-intl';

export default defineMessages({
    startCourse: {
        id: 'assign-course-legacy.components.startCourse',
        defaultMessage: 'Queue new default course for rollover'
    },
    searchCourse: {
        id: 'assign-course-legacy.components.searchCourse',
        defaultMessage: 'Search for a course'
    },
    selectGrade: {
        id: 'assign-course-legacy.components.selectGrade',
        defaultMessage: 'Select grade'
    },
    defaultOptionCountry: {
        id: 'assign-course-legacy.components.defaultOptionCountry',
        defaultMessage: 'Select country'
    },
    selectCourse: {
        id: 'assign-course-legacy.components.selectCourse',
        defaultMessage: 'Select course'
    },
    noCoursesFound: {
        id: 'assign-course-legacy.components.noCoursesFound',
        defaultMessage: 'No courses found'
    },
    schoolCourses: {
        id: 'assign-course-legacy.components.schoolCourses',
        defaultMessage: 'School courses'
    },
    coursesActivityMastery: {
        id: 'assign-course-legacy.components.coursesActivityMastery',
        defaultMessage: 'Courses (Activity Mastery)'
    },
    courses: {
        id: 'assign-course-legacy.components.courses',
        defaultMessage: 'Courses'
    },
    assignToGroup: {
        id: 'assign-course-legacy.components.assignToGroup',
        defaultMessage: 'Assign to group'
    },
    assignToYear: {
        id: 'assign-course-legacy.components.assignToYear',
        defaultMessage: 'Assign to year'
    }
});



// WEBPACK FOOTER //
// ./app/components/assign-course-legacy/messages.js